module.exports = __webpack_public_path__ + "img/thumbnail_Saiga_m_normal.e536fe76.png";